import React, { useState } from "react";
import {
  SFIcons,
  SFStack,
  SFIconButton,
  SFDropdown,
  SFAvatar,
  SFUseStyled,
  SFTypography,
} from "@sf-core";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const { styled } = SFUseStyled();

const SFAvatarStyled = styled(SFAvatar, {
  shouldForwardProp: (prop) => prop !== "isHomePage",
})(({ theme, isHomePage }) => ({
  width: 36,
  height: 36,
  marginRight: theme.spacing(0.5),
  marginTop: theme.spacing(0.3),
  border: `3px solid ${theme.palette.grey450.main}`,
  ...(isHomePage && {
    width: 25,
    height: 25,
    marginRight: theme.spacing(1.5),
    border: "none",
    marginTop: 0,
  }),
}));

const Divider = styled("div")(({ theme }) => ({
  width: "2px",
  height: "20px",
  backgroundColor: theme.palette.grey450.main,
  marginLeft: theme.spacing(1),
  marginTop: theme.spacing(0.2),
}));

const StyledSFStack = styled(SFStack, {
  shouldForwardProp: (prop) => prop !== "showAvatar",
})(({ theme, showAvatar }) => ({
  ...(showAvatar && {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    backgroundColor: theme.palette.grey600.main,
    borderRadius: theme.spacing(4),
    marginLeft: theme.spacing(1),
  }),
}));

const StyledIconButton = styled(SFIconButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.grey300.main,
}));

const StyledTypography = styled(SFTypography)(({ theme }) => ({
  color: theme.palette.grey300.main,
}));

const SFAvatarMenu = ({
  getDropDownActions = () => ({}),
  title = null,
  subTitle = null,
  showAvatar = false,
  isHomePage = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [dropDownMenu, setDropDownMenu] = useState({
    open: false,
    target: null,
  });
  const userAvatar = useSelector((state) => state.session.avatar);
  const dropDownMenuActions = getDropDownActions(navigate, t)?.actions;

  const handleOpendropDownMenu = (e) => {
    setDropDownMenu({ open: true, target: e.target });
  };

  return (
    <>
      <>
        {isHomePage ? (
          <>
            {showAvatar && <Divider />}
            <StyledSFStack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              showAvatar={showAvatar}
            >
              {showAvatar && (
                <>
                  <SFAvatarStyled src={userAvatar} isHomePage={isHomePage} />
                  <SFTypography variant="body1">{title}</SFTypography>
                </>
              )}
              {dropDownMenuActions?.length > 0 && (
                <SFIconButton
                  onClick={(e) => handleOpendropDownMenu(e)}
                  variant="transparent"
                >
                  <SFIcons.SFMoreVertIcon size="small" />
                </SFIconButton>
              )}
            </StyledSFStack>
          </>
        ) : (
          <SFStack direction="row" alignItems="center" justifyContent="center">
            <SFAvatarStyled src={userAvatar} isHomePage={isHomePage} />
            <SFStack direction="column" justifyContent="center">
              <SFStack direction="row" alignItems="center">
                <StyledTypography variant="body1">{subTitle}</StyledTypography>
                {dropDownMenuActions?.length > 0 && (
                  <StyledIconButton
                    onClick={(e) => handleOpendropDownMenu(e)}
                    variant="transparent"
                  >
                    <SFIcons.SFMoreVertIcon size="small" />
                  </StyledIconButton>
                )}
              </SFStack>
              <SFTypography variant="courseCarouselTitle" component="h3">{title}</SFTypography>
            </SFStack>
          </SFStack>
        )}
        <SFDropdown
          open={dropDownMenu.open}
          anchorEl={dropDownMenu.target}
          onClose={() => setDropDownMenu({ open: false })}
          items={dropDownMenuActions}
          position={isHomePage ? 85 : 15}
          placement={isHomePage ? "bottom" : "right"}
        />
      </>
    </>
  );
};

export default SFAvatarMenu;
